export function useSessionAuth() {
	const isTokenNearExpiry = (token: string | null) => {
		if (!token) return false;

		try {
			const payload = JSON.parse(atob(token.split(".")[1]));
			const expiryTime = payload.exp * 1000;
			const timeRemaining = expiryTime - Date.now();
			// 1 day in milliseconds = 24 * 60 * 60 * 1000 = 86_400_000
			return timeRemaining > 0 && timeRemaining < 24 * 60 * 60 * 1000;
		} catch (error) {
			console.error("Invalid token:", error);
			return false;
		}
	};

	return {
		isTokenNearExpiry,
	};
}
